<app-header-one></app-header-one>

<section class="listing-categories-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2><span class="library-text">Diseases</span></h2>
        </div>

      
        <div class="row">
            <div class="col-lg-3 col-md-4 col-sm-6" *ngFor="let disease of diseases">
                <div class="partner-item">
                    <mat-card>
                        <img [src]="disease.imageUri" alt="image" />

                        <mat-card-content>
                            <p class="library-name">
                                <span>{{disease.name}}</span>
                            </p>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>

           
        </div>
    </div>
</section>
